import { Component, Input, Output, EventEmitter, OnInit, input, computed } from '@angular/core'

import { FormsModule } from '@angular/forms'
import { SelectItem } from 'primeng/api'
import { Button } from 'primeng/button'
import { MultiSelect } from 'primeng/multiselect'
import { Popover } from 'primeng/popover'
import { isEqual } from 'lodash-es'

import { GenericColumnComponent } from '@app/components/generic/generic-column'
import { getVisibleColumns, setVisibleColumns } from '@app/components/generic/utilities'

@Component({
  selector: 'app-configure-fields',
  templateUrl: 'configure-fields.html',
  imports: [
    Button,
    Popover,
    MultiSelect,
    FormsModule,
  ],
})
export class ConfigureFieldsComponent implements OnInit {
  public allFieldsVisible: boolean = true

  @Input() visibleColumnKeys: string[] = []
  @Input({ required: true }) uniqueKey!: string

  allColumns = input<GenericColumnComponent[]>([])
  columnSelectItems = computed(() => this.allColumns().map(column => ({
    label: column.title,
    value: column.key,
  } as SelectItem<string>)))

  @Output() visibleColumnsEvent: EventEmitter<string[]> = new EventEmitter<string[]>()

  ngOnInit () {
    // if we have persisted column visibilities for this table, load them now
    const persistedColumns = getVisibleColumns(this.uniqueKey)
    if (persistedColumns && persistedColumns.length > 0) {
      this.visibleColumnKeys = persistedColumns
    }

    this.computeAllFieldsVisible()
  }

  onChangeFields () {
    this.visibleColumnsEvent.emit(this.visibleColumnKeys)
    // persist the new list of visible columns for this table
    setVisibleColumns(this.uniqueKey, this.visibleColumnKeys)

    this.computeAllFieldsVisible()
  }

  /**
   * Recompute the `allFieldsVisible` variable to control the warning badge on the button
   */
  private computeAllFieldsVisible () {
    const allColumnKeys = this.allColumns().map(c => c.key).toSorted((a, b) => a.localeCompare(b))
    const visibleKeys = this.visibleColumnKeys.toSorted((a, b) => a.localeCompare(b))
    this.allFieldsVisible = isEqual(allColumnKeys, visibleKeys)
  }
}
